export const content = {
    name: 'About Us',
    description: `At Elevate, we specialize in managing financial reporting and back-office 
                operations, giving you peace of mind to focus on growing your business. With an 
                experienced team and bespoke solutions, we deliver high-quality results tailored 
                to your unique needs, including custom reporting and expert CFO advice. Our flexible, 
                single-stop services are designed to align your financial operations with your vision for success.
    `,
  };